module.exports = __webpack_public_path__ + "img/s2Model3.0aae2e17.png";